module.exports = __webpack_public_path__ + "img/login-text.63f971a2.png";